





















import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name      : "StadiumCurator",
  props     : {
    id               : { type: String, required: true },
    editable         : { type: Boolean, required: true },
    button           : { type: Boolean, default: true },
    business_days_new: { type: Array, required: true },
  },
  data() {
    return {
      data   : [] as Array<any>,
      columns: [
        { align: "center", title: "", scopedSlots: { customRender: 'action' } },
        { align: "center", title: "节日", scopedSlots: { customRender: 'holiday' } },
        { align: "center", title: "天数（按年平均天数填写）", scopedSlots: { customRender: 'days' } },
      ],
    }
  },
  methods: {
    add_row() {
      this.data.push({ holiday: "", days: 0 })
    },
    onCellChange(i: number, t: string, e: any) {
      const source = [...this.data];
      const target = source[i]
      if (target) {
        target[t] = e.target.value;
        this.data = source;
      }
    },
    remove(index: string) {
      this.$confirm({
        content: "确定删除这条记录？",
        onOk: () => {
          const data = []
          for (const k in this.data) {
            if (this.data[k] && k != index) {
              data.push(this.data[k])
            }
          }
          this.data = this.$deep_copy(data)
        }
      })
    },
    submit() {
      const new_days = []
      for (const v of this.data) {
        if (v.days > 0) {
          new_days.push([v.holiday, v.days].join(","))
        }
      }
      const params = { estimate_id: this.id, business_days_new: new_days.join(";") }
      this.$emit("update:business_days_new", new_days)
      this.$emit("save", params)
    }
  },
  watch: {
    business_days_new(days: string[]) {
      if (days.length > 0) {
        this.data = []
        for (const v of days) {
          const item = v.split(",")
          this.data.push({ holiday: item[0], days: item[1] })
        }
      }
    }
  }
})
